module.exports = __webpack_public_path__ + "static/media/Sa 2.5e95d2f2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/Sa 2.mp3
// module id = 51
// module chunks = 0